<template>
    <div class="c-author-medals" v-if="ready">
        <div class="u-label">
            <i class="el-icon-trophy"></i>
            <!-- <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M346.005 512a14.998 14.998 0 01-9.884-3.714l-79.912-69.963-80.359 69.988A15.001 15.001 0 01150.999 497V261.02c0-8.284 6.716-15 15-15h180.003c8.284 0 15 6.716 15 15V497a15 15 0 01-14.997 15z" fill="#28c1d1"/><path d="M346.002 246.02H256v192.486l.209-.182 79.912 69.963a15 15 0 0024.881-11.286V261.02c0-8.285-6.716-15-15-15z" fill="#008896"/><path d="M256 356.574a14.999 14.999 0 01-12.99-7.5l-43.381-75.138h-84.465a14.999 14.999 0 01-12.99-22.5l42.233-73.149-42.233-73.149a14.998 14.998 0 0112.99-22.5h84.465L243.01 7.5a14.999 14.999 0 0125.98 0l43.381 75.138h84.465a14.999 14.999 0 0112.99 22.5l-42.233 73.149 42.233 73.149a14.998 14.998 0 01-12.99 22.5h-84.465l-43.381 75.138a14.999 14.999 0 01-12.99 7.5z" fill="#fff566"/><path d="M268.99 349.074l43.381-75.138h84.465a14.999 14.999 0 0012.99-22.5l-42.233-73.149 42.233-73.149a14.998 14.998 0 00-12.99-22.5h-84.465L268.99 7.5A14.999 14.999 0 00256 0v356.574a14.999 14.999 0 0012.99-7.5z" fill="#ffcf2c"/><path d="M312.586 273.936h84.251a14.999 14.999 0 0012.99-22.5l-42.233-73.149H256zM115.164 82.638a14.999 14.999 0 00-12.99 22.5l42.233 73.149H256l-56.585-95.649z" fill="#ffb500"/><path d="M396.837 82.638h-84.251L256 178.287h111.594l42.233-73.149a14.998 14.998 0 00-12.99-22.5z" fill="#ff9300"/><path d="M102.174 251.436a14.998 14.998 0 0012.99 22.5h84.251L256 178.287H144.406z" fill="#ffcf2c"/><path d="M93.36 193.29c-3.95 0-7.81-1.6-10.61-4.391-2.79-2.8-4.39-6.67-4.39-10.609 0-3.95 1.6-7.82 4.39-10.61 2.8-2.79 6.66-4.39 10.61-4.39s7.82 1.6 10.61 4.39 4.39 6.66 4.39 10.61-1.6 7.81-4.39 10.609a15.112 15.112 0 01-10.61 4.391z" fill="#ffb500"/><path d="M418.64 193.29c-3.95 0-7.81-1.6-10.61-4.391-2.79-2.8-4.39-6.67-4.39-10.609 0-3.95 1.6-7.82 4.39-10.61s6.66-4.39 10.61-4.39 7.81 1.6 10.61 4.39c2.79 2.79 4.39 6.66 4.39 10.61 0 3.94-1.6 7.81-4.39 10.609a15.13 15.13 0 01-10.61 4.391z" fill="#ff9300"/></svg> -->
            <span>作者荣誉</span>
        </div>
        <div class="u-medals" v-if="medals && medals.length">
            <el-tooltip
                class="item"
                effect="dark"
                :content="item.medal_desc"
                placement="top"
                v-for="item in medals"
                :key="item.id"
            >
                <a :href="getMedalLink(item)" target="_blank" class="u-medal">
                    <img class="u-medal-img" :src="showIcon(item.medal)" />
                </a>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import { getMedalLink } from "@jx3box/jx3box-common/js/utils";
import { getUserMedals } from "../../service/author";
import { __imgPath } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    name: "AuthorMedals",
    props: ["uid"],
    components: {},
    data: function () {
        return {
            medals: [],
        };
    },
    computed: {
        ready: function () {
            return this.uid && this.medals && this.medals.length;
        },
    },
    watch: {
        uid: {
            immediate: true,
            handler: function (val) {
                val && this.loadMedals();
            },
        },
    },
    methods: {
        loadMedals: function () {
            getUserMedals(this.uid).then((data) => {
                this.medals = data || [];
            });
        },
        showIcon(medal) {
            return __imgPath + "image/medals/user/" + medal + ".gif";
        },
        getMedalLink(medal) {
            return medal.rank_id ? getMedalLink(medal.rank_id, medal.medal_type || "rank") : "";
        },
    },
    created: function () {},
    mounted: function () {},
};
</script>

<style lang="less">
.c-author-medals {
    .u-medals {
        display: flex;
    }
    .u-medal {
        cursor: pointer;
        .mr(2px);
        .u-medal-img {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
